import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'row',
  height: 'auto',
  fontSize: '12rem',
});

export const PriceCell = styled.div({
  marginRight: '5rem',
  textDecoration: 'line-through',
});

export const PercentageCell = styled.div(({ theme }) => ({
  color: theme.defaultTheme.promotionColor,
}));
